import { render, staticRenderFns } from "./NbaGameDay.vue?vue&type=template&id=23662e3a&scoped=true"
import script from "./NbaGameDay.vue?vue&type=script&lang=js"
export * from "./NbaGameDay.vue?vue&type=script&lang=js"
import style0 from "./NbaGameDay.vue?vue&type=style&index=0&id=23662e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23662e3a",
  null
  
)

export default component.exports